/** Words on a tutor's pay card (your Tutors page, and the tutor's own Tutoring page). */

// ---- the top of the card
/** When no students are assigned to them yet. */
export const TUTOR_NO_STUDENTS = "No students assigned yet";
/** Hours and lessons ({hours} = "5 hours", {count} = 4, {sessions} = the word below). */
export const TUTOR_TAUGHT_TEXT = "{hours} taught over {count} {sessions}";
export const TUTOR_SESSION_WORD = "session";
export const TUTOR_SESSIONS_WORD = "sessions";

// ---- the numbers ({name} = the tutor's full name)

// ---- the note under the numbers. Empty hides it.

// ---- each lesson and payment ({date} = "Oct 14", {time} = "16:00–17:00", {hours} = "1 hour")
/** The method names. */
export const TUTOR_METHOD_ZELLE = "Zelle";
export const TUTOR_METHOD_CASH = "Cash";
export const TUTOR_METHOD_OTHER = "Other";
/** The button on a payout you logged, to take it out (logged by mistake). Empty hides it. */
export const TUTOR_REMOVE_PAYOUT = "Remove";
/** Pop-up after removing, and its undo button. */
export const TUTOR_REMOVED_TOAST = "Removed";
export const TUTOR_REMOVED_UNDO = "Undo";
/** Pop-up after undoing. */
export const TUTOR_RESTORED_TOAST = "Back";

// ---- logging money you paid a tutor yourself
/** The button ({name} = the tutor's full name). */
export const TUTOR_LOG_PAID_BUTTON = "Log money you paid {name}";
/** Pop-up after saving. */
export const TUTOR_LOG_PAID_TOAST = "Logged as paid to {name}";

// ---- the line under the Tutors list. Empty hides it.
export const TUTORS_FOOTNOTE = "";
/** The Edit field that links a tutor to their person in your groups, and its first choices. */
export const TUTOR_LINK_LABEL = "Same person in your groups";
export const TUTOR_LINK_BY_NAME = "Match by name when there's one clear match";
export const TUTOR_LINK_APART = "No one in my groups";

// ---- the calendar: marking a lesson done before it ends ({time} = "17:00", {hours} = "1 hour")
/** The question ({what} = the parts below, joined). */
export const CAL_EARLY_TEXT = "Ends at {time}. Mark it done now? {what}.";
/** Hourly student ({student} = full name). */
export const CAL_EARLY_CHARGED = "{student}'s family is charged for {hours}";
/** Prepaid student. */
export const CAL_EARLY_PREPAID = "{hours} comes off {student}'s prepaid hours";
/** The tutor's pay ({tutor} = full name, {amount} = "$20.00"): earned, not paid out. */
export const CAL_EARLY_EARNS = "{tutor} earns {amount} of tutoring pay";
/** On the tutor's own calendar. */
export const CAL_EARLY_TAUGHT = "it counts as {hours} taught";
/** Joins the parts. */
export const CAL_EARLY_JOIN = " and ";

// ---- one-time fixes, listed under the tutors ({when} = date and time, {what} = what it did)
/** Heading. Empty hides the list. */
export const TUTORS_FIXES_TITLE = "Fixes applied";
export const TUTORS_FIX_LINE = "{when}: {what}";

// ---- a tutor on the shared person card ({hours} = "5 hours", {count}, {sessions} as above)
/** Their status. */
export const TUTOR_STATUS_OFF = "Not on the site yet";
export const TUTOR_STATUS_ON = "On the site: takes lessons, marks them done, logs exact times";
export const TUTOR_STATUS_WAIT = "Account linked: waiting for them to confirm it's them";
/** Buttons and forms on a tutor. */
export const TUTOR_BOUGHT_BUTTON = "They bought something";
export const TUTOR_SCHEDULE_LINK = "Their schedule";
export const TUTOR_EDIT_BUTTON = "Edit";
export const TUTOR_FORM_AMOUNT = "Amount";
export const TUTOR_FORM_DATE = "Date";
export const TUTOR_FORM_HOW = "How";
export const TUTOR_FORM_WHAT = "What";
export const TUTOR_FORM_PRICE = "Price";
export const TUTOR_FORM_SAVE = "Save";
export const TUTOR_FORM_CANCEL = "Cancel";
/** When there are no tutors yet. */
export const TUTORS_EMPTY =
  "No tutors yet. Add the people who teach for you; you set their pay per student.";

// ---- a student's prepaid bar: green is what's still free, yellow is booked (it eats into the
// green), grey is done. {n} = "3", {prepaid} = "10", {word} = "hours" or "lessons".
export const BAR_USED = "of {prepaid} {word} used";
export const BAR_LEFT = "{n} left";
export const BAR_OVER = "{n} over";
/** The key under the bar, in the bar's order. Empty hides that one. */
export const BAR_LEGEND_LEFT = "{n} left";
export const BAR_LEGEND_BOOKED = "{n} booked";
export const BAR_LEGEND_DONE = "{n} done";

// ---- the calendar's page and its session cards. Empty hides any of these.
/** The line under each Tutoring page's title. */
export const TUTORING_LEDE_STUDENTS = "";
export const TUTORING_LEDE_CALENDAR = "";
export const TUTORING_LEDE_TUTORS = "";
export const TUTORING_LEDE_PACKAGES = "";
/** The note above the packages. */
export const PACKAGES_NOTE = "";
/** Under a booked session ({time} = when it ends). */
export const CAL_BOOKED_NOTE = "";
export const CAL_ON_NOW_NOTE = "";
/** Under a done session: how it was logged. */
export const CAL_LOGGED_AUTO = "";
export const CAL_LOGGED_HAND = "";
/** Under a session marked not done. */
export const CAL_MISSED = "Didn't happen";
/** Show the note on the Schedule a session form about hours and pay. */
export const SHOW_CAL_FORM_NOTE = false;
/** Each week's line ({range} = "Oct 19–25"); the open week's line folds it. */
export const CAL_WEEK_OPEN = "";
export const CAL_WEEK_CLOSE = "";
export const CAL_WEEK_NONE = "No lessons";
/** Changing a session right on its card. */
export const CAL_EDIT = "Edit";
export const CAL_EDIT_SAVE = "Save";
export const CAL_EDIT_CANCEL = "Cancel";
export const CAL_EDIT_DATE = "Date";
export const CAL_EDIT_FROM = "From";
export const CAL_EDIT_TO = "To";
export const CAL_EDIT_STUDENT = "Student";
export const CAL_EDIT_TUTOR = "Tutor";
export const CAL_EDIT_NOTE = "Note";
export const CAL_EDIT_OPEN_TIME = "Open time";
export const CAL_EDIT_YOU = "You";
export const CAL_EDIT_BAD_TIME = "The end time is before the start";
export const CAL_EDIT_SAVED = "Saved";

// ---- tutors take students (2026-11-02). Empty hides any of these.
/** The Tutor choice for a lesson or student waiting for a tutor. */
export const CLAIM_NEEDS_TUTOR = "Needs a tutor";
/** On a lesson waiting for a tutor, Miles's view. */
export const CLAIM_NEEDS_TUTOR_TAG = "Needs a tutor";
/** A tutor's buttons: taken right away with a market price ({pay} = "$24.00/hr"), else a request. */
export const CLAIM_TAKE_LESSON = "Take this lesson";
export const CLAIM_ASK_LESSON = "Ask to take it";
export const CLAIM_TAKE_STUDENT = "Take {name}";
export const CLAIM_ASK_STUDENT = "Ask to take {name}";
/** The market price shown to tutors. */
export const CLAIM_PAY = "Pays {pay}";
/** When no market price is listed (Miles sets the pay when he approves). */
export const CLAIM_PAY_UNLISTED = "Pay set by Miles";
/** Pop-ups after taking or asking. */
export const CLAIM_TAKEN_TOAST = "It's yours";
export const CLAIM_ASKED_TOAST = "Asked. Miles will let you know.";
/** A tutor's waiting request, and taking it back. */
export const CLAIM_WAITING = "You asked for it. Waiting for Miles.";
export const CLAIM_WITHDRAW = "Take back";
/** The tutor's section of students and lessons waiting for a tutor. */
export const OPEN_TITLE = "Up for grabs";
export const OPEN_EMPTY = "";
/** One student waiting ({lessons} = "2 lessons waiting"). */
export const OPEN_LESSONS_ONE = "1 lesson waiting";
export const OPEN_LESSONS_MANY = "{n} lessons waiting";
/** The tutor's own requests. */
export const MY_REQUESTS_TITLE = "Your requests";
export const REQUEST_STATUS_PENDING = "Waiting for Miles";
export const REQUEST_STATUS_APPROVED = "Yours";
export const REQUEST_STATUS_DECLINED = "Not this time";
export const REQUEST_STATUS_WITHDRAWN = "Taken back";

// ---- Miles: tutors' requests ({tutor}, {what} = a student's name or "Wen Li, Mon Nov 3 16:00")
export const REQUESTS_TITLE = "Requests from tutors";
export const REQUEST_LINE = "{tutor} asked to take {what}";
export const REQUEST_STUDENT_WHAT = "{name} (all their lessons)";
export const REQUEST_PAY_LABEL = "Pay ($/hr)";
export const REQUEST_APPROVE = "Approve";
export const REQUEST_DECLINE = "Decline";
export const REQUEST_APPROVED_TOAST = "Approved";
export const REQUEST_DECLINED_TOAST = "Declined";

// ---- a student's tutor pay, set per student and tutor ({pay} = "$20.00/hr")
export const PAIR_TITLE = "Tutor pay";
export const PAIR_LINE = "{tutor} · {pay}";
/** The default before Miles sets one. */
export const PAIR_DEFAULT = "{pay} (minimum wage until you set it)";
export const PAIR_SET = "Set pay";
export const PAIR_TUTOR = "Tutor";
export const PAIR_PAY = "Pay ($/hr)";
export const PAIR_PAST = "Also for lessons they already taught";
export const PAIR_SAVED = "Pay saved";
/** The student form: looking for a tutor, and the market price. */
export const STUDENT_SEEKING = "Looking for a tutor (every tutor sees their name and class)";
export const STUDENT_MARKET = "Market price for tutors ($/hr; empty: not listed, you approve)";
/** Tags on a student's card. */
export const STUDENT_SEEKING_TAG = "Needs a tutor";
export const STUDENT_MARKET_TAG = "market {pay}";
/** A tutor's card: their students with their pay ({list}). */
export const TUTOR_PAIRS_TEXT = "{list}";

// ---- the calendar, new pieces
/** A lesson that already happened, on the Schedule form. */
export const CAL_PAST_NOTE = "Already happened: it's logged as done when you save.";
/** A tutor logging the exact times of their own lesson. */
export const CAL_TIMES = "Exact times";
export const CAL_TIMES_SAVED = "Times saved";
/** Under a lesson whose times a tutor set ({name}). */
export const CAL_TIMES_BY = "Times from {name}";
/** On a tutor's calendar, a paired student's lesson someone else teaches ({name}). */
export const CAL_WITH = "with {name}";
/** The schedule form's student placeholder. */
export const CAL_PICK_STUDENT = "Pick a student";
/** The chip that shows only lessons waiting for a tutor. */
export const CAL_CHIP_OPEN = "Needs a tutor";
/** Your own lessons (no tutor). */
export const CAL_YOU = "You";

// ---- Tutoring on the Overview, like a group ({n}, {date})
export const OV_TUTORING_TITLE = "Tutoring";
export const OV_TUTORING_PEOPLE = "{students} students · {tutors} tutors";
export const OV_TUTORING_LESSONS = "Lessons this month";
export const OV_TUTORING_LAST = "Last lesson";
export const OV_TUTORING_NEXT = "Next lesson";
export const OV_TUTORING_NONE = "None yet";
export const OV_TUTORING_NEEDS = "{n} need a tutor";
export const OV_TUTORING_REQUESTS = "{n} requests";
export const OV_TUTORING_UP = "Up for grabs";
